// Web3 错误处理和重连机制
import Web3 from 'web3';

class Web3ErrorHandler {
    constructor() {
        this.retryCount = 0;
        this.maxRetries = 3;
        this.retryDelay = 1000; // 1秒
    }

    // 检查提供者是否可用
    async checkProvider(provider) {
        try {
            if (!provider) return false;
            
            // 检查是否是 MetaMask 或类似的钱包
            if (provider.isMetaMask || provider.isConnected) {
                return await provider.isConnected();
            }
            
            // 检查是否是 HTTP 提供者
            if (provider.host) {
                const web3 = new Web3(provider);
                const blockNumber = await web3.eth.getBlockNumber();
                return blockNumber !== null;
            }
            
            return false;
        } catch (error) {
            console.error('Provider check failed:', error);
            return false;
        }
    }

    // 获取可用的提供者
    async getAvailableProvider() {
        const providers = [
            window.myprovider,
            window.ethereum,
            window.web3?.currentProvider,
            new Web3.providers.HttpProvider("http://127.0.0.1:8545/"),
            new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/YOUR_PROJECT_ID"),
            new Web3.providers.HttpProvider("https://bsc-dataseed.binance.org/")
        ];

        for (const provider of providers) {
            if (provider && await this.checkProvider(provider)) {
                console.log('Available provider found:', provider.constructor.name);
                return provider;
            }
        }

        throw new Error('No available Web3 provider found');
    }

    // 创建 Web3 实例，带重试机制
    async createWeb3Instance() {
        try {
            const provider = await this.getAvailableProvider();
            const web3 = new Web3(provider);
            
            // 测试连接
            await web3.eth.getBlockNumber();
            
            this.retryCount = 0; // 重置重试计数
            return web3;
        } catch (error) {
            console.error(`Web3 creation failed (attempt ${this.retryCount + 1}):`, error);
            
            if (this.retryCount < this.maxRetries) {
                this.retryCount++;
                await this.delay(this.retryDelay * this.retryCount);
                return this.createWeb3Instance();
            }
            
            throw new Error(`Failed to create Web3 instance after ${this.maxRetries} attempts: ${error.message}`);
        }
    }

    // 延迟函数
    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // 处理合约调用错误
    handleContractError(error, contractName, methodName) {
        console.error(`Contract error in ${contractName}.${methodName}:`, error);
        
        if (error.message.includes('Script runner not loaded')) {
            return {
                type: 'SCRIPT_RUNNER_ERROR',
                message: '区块链脚本运行器未加载，请检查钱包连接或刷新页面',
                retryable: true
            };
        }
        
        if (error.message.includes('User denied transaction')) {
            return {
                type: 'USER_DENIED',
                message: '用户取消了交易',
                retryable: false
            };
        }
        
        if (error.message.includes('insufficient funds')) {
            return {
                type: 'INSUFFICIENT_FUNDS',
                message: '账户余额不足',
                retryable: false
            };
        }
        
        return {
            type: 'UNKNOWN_ERROR',
            message: error.message || '未知错误',
            retryable: true
        };
    }
}

// 创建单例实例
const web3ErrorHandler = new Web3ErrorHandler();

export default web3ErrorHandler;

